import { createSlice } from '@reduxjs/toolkit';
import { UserDetailStateType } from 'src/types/userDetail';

const initialState: UserDetailStateType = {
    data: null,
    loading: false,
    error: false,
};
export const userDetailSlice = createSlice({
    name: 'userDetail',
    initialState,
    reducers: {
        getUserDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getUserDetailFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getUserDetailFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        createUserDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        createUserDetailFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        createUserDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        updateUserDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        updateUserDetailFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        updateUserDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        clearUserDetail: () => initialState,
    },
});

export const {
    getUserDetailFetch,
    getUserDetailFetchSuccess,
    getUserDetailFetchFailure,
    createUserDetailFetch,
    createUserDetailFetchSuccess,
    createUserDetailFetchFailure,
    updateUserDetailFetch,
    updateUserDetailFetchSuccess,
    updateUserDetailFetchFailure,
    clearUserDetail,
} = userDetailSlice.actions;

export default userDetailSlice.reducer;
